import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import Icon from 'components/patterns/Icon'

export const InfoIcon = styled(Icon)`
  fill: ${themeColor('blackSecondary')};
  &&& {
    height: 16px;
    width: 24px;
    top: 12px;
    left: 13px;
  }
`
export const TwoPositionMessage = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 5px;
`
